import { connect } from "react-redux";
import {
	calculateCreditBasedOnQuoteBase,
	calculatePreBookTotal,
	isBookingEligibleForDeposit,
} from "app/pages/Booking/bookingSelectors";
import QuotationPriceSummary from "app/pages/.shared/PriceSummary/QuotationPriceSummary";
import {
	checkIsCreditUsageIsEnabled,
	getPartnerDepositPercentage,
} from "app/reducers/partnerSelector";
import { getAvailablePaymentTerms } from "app/reducers/partnerSelector";
import { getAvailablePaymentMethods } from "app/pages/Booking/Payment/paymentSelector";

const mapStateToProps = state => {
	const isCreditEnabled = checkIsCreditUsageIsEnabled(state);
	const creditsApplied = isCreditEnabled ? calculateCreditBasedOnQuoteBase(state) : 0;
	const total = calculatePreBookTotal(state) - creditsApplied;
	return {
		hasChildren: state.booking.children > 0,
		depositPercentage: getPartnerDepositPercentage(state),
		availablePaymentTerms: getAvailablePaymentTerms(state),
		availablePaymentMethods: getAvailablePaymentMethods(state),
		isBookingEligibleForDeposit: isBookingEligibleForDeposit(state),
		total: total,
		resolution: state.resolution,
	};
};

export default connect(mapStateToProps)(QuotationPriceSummary);
